module.exports = "/images/logo_landing.png?a2e0ad70d35284c3295debb9182a1287";